declare const $: any;

/**
 * Froala editor function that prevents multi line text
 */
export const preventMultilineText = function(clipboardHtml: string) {
  if (typeof $ !== 'function') return;
  return $('<div/>').html(clipboardHtml).text().trim().replace(/\n/g, ' ');
};
